// API utility functions to replace direct Supabase calls
import { ApiClient as BaseClient } from '../shared/api/client'
import { createAuthApi } from '../shared/api/auth'
import { createIntegrationsApi } from '../shared/api/integrations'
import { createDecksApi } from '../shared/api/decks'
import { createProfileApi } from '../shared/api/profile'
import { createStudyApi } from '../shared/api/study'
import { createResourcesApi } from '../shared/api/resources'
import { createAdminApi } from '../shared/api/admin'
import { createMarketplaceApi } from '../shared/api/marketplace'

class ApiClient extends BaseClient {
  constructor() {
    super()
    Object.assign(this, createAuthApi(this))
    Object.assign(this, createIntegrationsApi(this))
    Object.assign(this, createDecksApi(this))
    Object.assign(this, createProfileApi(this))
    Object.assign(this, createStudyApi(this))
    Object.assign(this, createResourcesApi(this))
    Object.assign(this, createAdminApi(this))
    Object.assign(this, createMarketplaceApi(this))
  }
}

export const api = new ApiClient()
